// U4: the one line a card that needs a reply shows while it has neither a draft nor a question:
// Claude writing it ahead, "Paused to save spend. Press e to draft.", or "No draft yet". Calm, no
// counts; pressing the words (or `e`) asks Claude for the draft.
import { useQueryClient } from "@tanstack/react-query";
import { PenLine } from "lucide-react";
import type { CardView } from "@shared/api";
import { Kbd } from "@web/ui/Kbd";
import { askForDraft, useDraftRequest } from "./draftAhead";
import { draftLine } from "./draftWords";

export function DraftNotice({ card, actionable }: { card: CardView; actionable: boolean }) {
  const queryClient = useQueryClient();
  const requested = useDraftRequest(card.id);
  const line = draftLine(card, requested, actionable);
  if (!line) return null;
  return (
    <p
      data-testid="draft-notice"
      data-tone={line.tone}
      aria-live="polite"
      className="flex flex-wrap items-center gap-x-1.5 gap-y-1 text-sm text-muted"
    >
      <PenLine
        aria-hidden
        className={line.tone === "writing" ? "size-4 animate-pulse text-calm" : "size-4"}
      />
      <span>{line.text}</span>
      {line.offerDraft ? (
        <button
          type="button"
          className="inline-flex items-center gap-1 text-accent-text underline-offset-2 hover:underline"
          onPointerDown={(e) => e.preventDefault()}
          onClick={() => void askForDraft(queryClient, card.id)}
        >
          Press <Kbd>E</Kbd> to draft.
        </button>
      ) : null}
    </p>
  );
}
